import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import DropdownSelect from '../../Components/DropdownSelect';
import { useDispatch } from 'react-redux';
import { updateUser } from '../../redux/auth/actions';
import { useTheme } from '@mui/material';
import { getUserTimezone } from '../../helpers/datetime';

const defaultTimezoneDisplay = 'Brand/System Default';

const TimezoneDropdown = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { tz, tz_source } = getUserTimezone();

  const getTimezoneOptions = () => {
    const defaultOption = {
      label: defaultTimezoneDisplay,
      value: '',
    };
    const timezoneOptions = Intl.supportedValuesOf('timeZone').map((tz) => ({
      label: tz,
      value: tz,
    }));
    return [defaultOption, ...timezoneOptions];
  };

  const getTimezoneOffset = (timezone) => {
    if (!timezone) {
      // For system default, use local timezone
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    const date = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    });
    const parts = formatter.formatToParts(date);
    const offset = parts.find((part) => part.type === 'timeZoneName')?.value || '';
    return offset;
  };

  const handleTimezoneChange = (value) => {
    if (value !== tz) {
      dispatch(updateUser('dashboard_timezone', value, { dashboard_timezone: value }));
    }
  };

  return (
    <Box data-use-translation={false} p={0} data-testid="timezone-dropdown">
      <DropdownSelect
        menuSlotProps={{
          paper: {
            id: 'timezone-options',
            sx: {
              height: '80vh',
            },
          },
        }}
        onSelect={handleTimezoneChange}
        value={tz}
        options={getTimezoneOptions()}
        customLabel={
          <Box display="flex" alignItems="center" gap={2}>
            <Tooltip title={(tz_source || 'System') + ' Timezone'}>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  color: theme.palette.text.primary,
                }}
              >
                {getTimezoneOffset(tz)}
              </Typography>
            </Tooltip>
          </Box>
        }
        showArrow={false}
        buttonProps={{
          sx: {
            border: `1px solid ${theme.palette.grey[500]}`,
            padding: '4px 8px',
            '&:hover': {
              border: `1px solid ${theme.palette.grey[500]}`,
            },
            cursor: 'pointer',
          },
          variant: 'outlined',
        }}
        preventTranslation={true}
      />
    </Box>
  );
};

export default TimezoneDropdown;
